import { zodResolver } from "@hookform/resolvers/zod";
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
import { OrderFormData, orderFormSchema } from "../OrderForm.schema";

export function useOrderForm(initialData?: Partial<OrderFormData>) {
  return useForm<OrderFormData>({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: zodResolver(orderFormSchema) as any,
    defaultValues: {
      dpPortfolioId: "",
      dpPortfolioName: "",
      dpPortType: "",
      dpModelType: "",
      dpAmountToInvest: 0,
      dpOnOffPercentage: "0",
      dpManagementFee: "1.5",
      dpFeeType: "all" as const,
      dpOnOffAmount: 0,
      dpOnOffDate: dayjs().format("DD.MM.YYYY"),
      dpAccount: "",
      dpNewAccount: "",
      dpWithdrawal: 0,
      ordreModul: "no" as const,
      buyOrders: [],
      sellOrders: [],
      dpSavingsEnabled: false,
      dpSavingsAmount: undefined,
      dpSavingsDayOfMonth: undefined,
      dpSavingsAvtalegiro: false,
      dpSavingsFunds: [],
      dpWithdrawalEnabled: false,
      dpWdAccount: "",
      dpWdDayOfMonth: undefined,
      dpWdAmount: undefined,
      askToAsk: false,
      moveAll: false,
      moveFrom: "",
      moveFromId: "",
      Instrument1: "",
      InstrumentAmt1: undefined,
      Instrument2: "",
      InstrumentAmt2: undefined,
      Instrument3: "",
      InstrumentAmt3: undefined,
      Instrument4: "",
      InstrumentAmt4: undefined,
      Instrument5: "",
      InstrumentAmt5: undefined,
      Instrument6: "",
      InstrumentAmt6: undefined,
      ...initialData,
    },
  });
}
